<template>
  <div>
    <!-- LOGIN FORM//S -->
    <div class="well">
      <div class="certification-row">
        <div class="cert-title">
          {{ $t("mypage.verify.emailVerification") }}
        </div>
        <div>{{ email || "-" }}</div>
        <div class="input-area">
          <button
            v-bind:class="{ 'btn-agree-view': true, completed: !emailConfirm }"
            :disabled="emailConfirm"
          ></button>
        </div>
      </div>
      <div class="certification-row">
        <div class="cert-title">{{ $t("mypage.verify.IDVerification") }}</div>
        <div v-if="userConfirm">{{ phone || "-" }}</div>
        <div class="input-area" v-if="userConfirm">
          <button
            v-bind:class="{ 'btn-agree-view': true, completed: !emailConfirm }"
            :disabled="emailConfirm"
          ></button>
        </div>
        <div class="phone-auth-container" v-else>
          <vs-row>
            <vs-col vs-w="12">
              <vs-input
                v-model="inputForm.name"
                :label-placeholder="$t('mypage.modify.이름')"
                :disabled="messageSent"
              ></vs-input>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="12" style="margin-top: 17px;">
              <vs-select
                autocomplete
                :placeholder="$t('mypage.verify.country')"
                v-model="inputForm.countryIndex"
                :disabled="messageSent"
              >
                <vs-select-item
                  v-for="country in countryCodes"
                  :key="country.cntidx"
                  :text="country.cntName"
                  :value="country.cntidx"
                ></vs-select-item>
              </vs-select>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12">
            <vs-col vs-w="3">
              <vs-input
                v-model="inputForm.countryCode"
                readonly
                disabled
                :label-placeholder="$t('mypage.verify.countryCode')"
              ></vs-input>
            </vs-col>
            <vs-col vs-w="8" vs-offset="1">
              <vs-input
                v-model="inputForm.phoneNumber"
                :disabled="messageSent"
                :style="{ fontSize: 9 }"
                :label-placeholder="$t('mypage.verify.phone')"
              ></vs-input>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" v-if="!messageSent">
            <vs-col vs-w="12" style="margin-top: 17px;">
              <vs-button
                @click="sendForeignPhone"
                size="small"
                style="width: 100%"
                color="success"
                type="border"
                >{{ $t("sms.sendVerification") }}</vs-button
              >
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" v-if="messageSent">
            <vs-col vs-w="12">
              <vs-input
                v-model="inputForm.authNumber"
                :label-placeholder="$t('mypage.verify.CertificationNumber')"
              ></vs-input>
              <span class="remain-time">{{ messageConfirmRemainTime }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" v-if="messageSent">
            <vs-col vs-w="12" style="margin-top: 17px;">
              <vs-button
                @click="requestForeignPhoneAuth"
                size="small"
                style="width: 100%"
                color="success"
                type="border"
                >{{ $t("mypage.modify.verify") }}</vs-button
              >
            </vs-col>
          </vs-row>
        </div>
      </div>
      <!-- OTP 인증//S -->
      <div class="certification-row">
        <div class="cert-title">{{ $t("mypage.verify.OTPRegister") }}</div>
        <div>{{ otpDate || "-" }}</div>
        <div class="input-area">
          <button
            v-if="otpConfirm"
            v-bind:class="{ 'btn-agree-view': true, 'cert-cancel': otpConfirm }"
            @click="otpUpdate"
          >
            {{ $t("mypage.modify.completeVerify") }}
          </button>
          <button
            v-else
            v-bind:class="{ 'btn-agree-view': true, 'cert-cancel': otpConfirm }"
            @click="otpUpdate"
          >
            {{ $t("mypage.modify.verify") }}
          </button>
        </div>
      </div>
      <!-- OTP 인증//E -->
      <!-- KYC //E -->
      <div class="certification-row">
        <div class="cert-title">{{ $t("mypage.verify.proofOfResidence") }}</div>
        <div>
          {{
            authResidence === "E"
              ? userInfo.authInfo.mpAltertime ||
                userInfo.authInfo.mpRegtime ||
                "-"
              : "-"
          }}
        </div>
        <div class="input-area">
          <button
            v-if="authResidence"
            v-bind:class="{
              'btn-agree-view': true,
              completed: residenceConfirm && authResidence === 'E',
            }"
            @click="residence"
          >
            {{ $t("mypage.modify.completeVerify") }}
          </button>
          <button
            v-else
            v-bind:class="{
              'btn-agree-view': true,
              completed: residenceConfirm && authResidence === 'E',
            }"
            @click="residence"
          >
            {{ $t("mypage.verify.verify") }}
          </button>
        </div>
      </div>
      <!-- KYC //E -->
    </div>
    <!-- 필수 인증 안내//S -->
    <vs-popup title="필수 인증 안내" :active.sync="necessaryCertifiaction">
      <p class="text-center">
        먼저 [미완료 인증 절차 : 예, 본인인증]을 완료하세요.
      </p>
      <vs-button
        color="primary"
        @click="necessaryCertifiaction = false"
        class="btn-block custom"
        type="filled"
        >확인</vs-button
      >
    </vs-popup>
    <!-- 필수 인증 안내//E -->
    <!-- OTP 인증 해지//S -->
    <vs-popup :title="$t('otpCancel.title')" :active.sync="removeOTPModal">
      <p class="text-center">
        <span v-html="$t('otpCancel.content[0]')"></span>
        <br />
        <span v-html="$t('otpCancel.content[1]')"></span>
        <br />
        <br />
        <span v-html="$t('otpCancel.content[2]')"></span>
        <br />
        <br />
        {{ $t("verificationReset.24hSecurityPolicy") }}
        <br />
        <br />
        {{ $t("otpCancel.content[3]") }}
        <vs-input
          class="input-otp"
          :placeholder="$t('otp.sixDigits')"
          v-model="otpNumber"
        ></vs-input>
        <br />
        {{ $t("otpCancel.content[4]") }}
      </p>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            @click="removeOTPModal = false"
            class="btn-block custom"
            type="filled"
            >{{ this.$t("confirm.cancel") }}</vs-button
          >
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
          <vs-button
            color="primary"
            @click="otpDelete"
            class="btn-block custom"
            type="filled"
            >{{ this.$t("confirm.ok") }}</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- OTP 인증 해지//E -->
  </div>
</template>
<script>
import Api from "@/common/Api";
import { mapGetters } from "vuex";
import GlobalEvent from "@/common/Event";
import moment from "moment";

export default {
  created() {
    Api.User.getCountryCodes().then((response) => {
      this.countryCodes = _.get(response, ["data", "result"], []);
    });

    this.getUserPrivateInfo();

    this.messageConfirmTimer = setInterval(this.checkTime.bind(this), 1000);
  },
  data() {
    return {
      phone: "",
      email: "",
      countryCodes: [],
      messageSent: null,
      messageConfirmTimer: null,
      messageConfirmExpire: 0,
      messageConfirmRemainTime: 0,
      messageRequestCode: null,
      inputForm: {
        name: "",
        countryCode: "",
        countryIndex: "",
        phoneNumber: "",
        authNumber: "",
      },
      removeOTPModal: false,
      KYCModal: false,
      necessaryCertifiaction: false,
      removeOTPModal: false,
      otpNumber: "",
    };
  },
  computed: {
    ...mapGetters([
      "authStep",
      "authLevel",
      "userInfo",
      "accounts",
      "useOTP",
      "authResidence",
    ]),
    emailConfirm() {
      return false;
    },
    userConfirm() {
      return this.authLevel > 1;
    },
    bankConfirm() {
      return this.accounts.deposit !== null && this.accounts.withdraw !== null;
    },
    otpConfirm() {
      return _.get(this, ["userInfo", "authInfo", "otp"], "N") === "Y";
    },
    otpDate() {
      return _.get(this, ["userInfo", "authInfo", "otpDate"], "");
    },
    residenceConfirm() {
      return this.authResidence;
    },
  },
  methods: {
    getUserPrivateInfo() {
      this.$store.dispatch("updateUserInfo");
      Promise.all([
        Api.User.getUserPrivateInfo("email"),
        Api.User.getUserPrivateInfo("phone"),
      ]).then(([email, phone]) => {
        this.email = email.body.data;
        this.phone = phone.body.data;
      });
    },
    checkTime() {
      if (this.messageSent) {
        if (this.messageConfirmExpire < moment()) {
          this.messageConfirmExpired();
          return false;
        }
        this.messageConfirmRemainTime = moment(
          moment(this.messageConfirmExpire).diff()
        ).format("mm분 ss초");
      }
    },
    sendForeignPhone() {
      // validation
      if (!this.inputForm.name) {
        this.$vs.notify({
          title: "오류",
          text: "이름을 입력해 주세요.",
          color: "danger",
        });
        return false;
      }
      if (!this.inputForm.countryCode) {
        this.$vs.notify({
          title: "오류",
          text: "국가를 선택해 주세요.",
          color: "danger",
        });
        return false;
      }
      if (!this.inputForm.phoneNumber) {
        this.$vs.notify({
          title: "오류",
          text: "휴대폰 번호를 입력해 주세요.",
          color: "danger",
        });
        return false;
      }

      const phoneNumber = this.inputForm.phoneNumber.replace(/\D/g, "");

      Api.User.requestForeignPhoneAuthCode(
        this.inputForm.name,
        this.inputForm.countryIndex,
        this.inputForm.countryCode,
        phoneNumber
      ).then((response) => {
        this.messageRequestCode = response.data.result.requestCode;
        this.messageSent = true;
        this.messageConfirmExpire = moment().add(3, "m");
        this.checkTime();
      });
    },
    requestForeignPhoneAuth() {
      const phoneNumber = this.inputForm.phoneNumber.replace(/\D/g, "");
      Api.User.validateForeignPhoneAuthCode(
        this.inputForm.name,
        this.inputForm.countryIndex,
        phoneNumber,
        this.messageRequestCode,
        this.inputForm.authNumber
      )
        .then((response) => {
          this.$vs.notify({
            title: "확인",
            text: "휴대폰 인증이 완료되었습니다.",
          });
          this.$store.dispatch("updateUserInfo");
          this.closeMessageConfirmation();
        })
        .catch((err) => {
          const msg = err.code ? err.msg : "잘못된 요청입니다.";
          this.$vs.notify({ title: "오류", text: msg, color: "danger" });
        });
    },
    closeMessageConfirmation() {
      this.messageRequestCode = null;
      this.messageSent = false;
      this.messageConfirmExpire = 0;
    },
    messageConfirmExpired() {
      this.closeMessageConfirmation();
      this.$vs.notify({
        title: "인증시간 초과",
        text: "휴대폰 인증 시간이 초과되었습니다.",
        color: "danger",
      });
    },
    otpUpdate() {
      if (this.authLevel < 2 || !this.phone || this.phone === "") {
        this.notiNotAllowed("본인인증");
        return false;
      }
      if (this.otpConfirm) {
        this.removeOTPModal = true;
      } else {
        this.$router.push({ name: "OtpConfirm" });
      }
    },
    otpValid() {
      if (!this.otpNumber) {
        this.failNoti("인증번호를 입력해주세요.", "인증");
        return false;
      }
      return true;
    },
    otpDelete() {
      if (this.otpValid()) {
        Api.User.terminateOTP(this.otpNumber)
          .then((response) => {
            this.$vs.notify({
              duration: 3000,
              title: "완료",
              type: "warning",
              text: "OTP 설정이 해제 되었습니다.",
              customClass: "dexko-noti",
              position: "top-left",
            });
            this.removeOTPModal = false;
            this.getUserPrivateInfo();
            //
            // this.$refs.otpForm.resetFields();
          })
          .catch((e) => {
            this.failNoti("인증번호가 잘못되었습니다.", "인증");
            this.otpNumber = "";
          });
      }
    },
    residence() {
      if (this.authLevel < 2) {
        this.notiNotAllowed("본인인증");
        return false;
      }
      if (!this.useOTP) {
        this.notiNotAllowed("OTP 인증");
        return false;
      }
      if (this.authResidence == "R") {
        // this.residenceModal = true;
        this.ResidenceModal();
        return false;
      }
      if (this.residenceConfirm) {
        return false;
      }
      this.goResidence();
    },
    goResidence() {
      //this.residenceModal = false
      setTimeout(() => {
        this.$router.push({ name: "KYC" });
      }, 50);
    },
    ResidenceModal() {
      var text =
        "<p class='text-center'>현재 FLYBIT 운영자가 사용자 증명을 위한 인증서류를 확인 중입니다.<br>인증서류의 재등록 시 사용자 증명 또한 다시 신청되기 때문에<br>인증 완료까지 추가 기간이 발생될 수 있습니다.</p>";
      this.$ev.$emit("popup", {
        title: "사용자 등록",
        content: text,
        hasHTML: true,
        buttons: [
          {
            type: "CANCEL",
            text: this.$t("confirm.cancel"),
            closeOnClick: true,
          },
          {
            type: "OK",
            text: "재등록",
            onClick: () => {
              this.goResidence();
            },
          },
        ],
      });
    },
    notiNotAllowed(step) {
      this.$vs.notify({
        title: "인증센터",
        text: `먼저 ${step}을 완료하세요.`,
        type: "warning",
        customClass: "dexko-noti",
        position: "top-left",
      });
    },
  },
  watch: {
    "inputForm.countryIndex"(newVal) {
      this.inputForm.countryCode = _.get(
        this.countryCodes.find((country) => country.cntidx === newVal),
        ["cntLocalCode"],
        null
      );
    },
  },
  destroyed() {
    clearInterval(this.messageConfirmTimer);
  },
};
</script>
<style lang="scss" scoped>
.btn-wide {
  width: 100px;
}
.con-select {
  width: auto;
}
.certification-row {
  & ::v-deep .vs-con-input-label {
    width: 100%;
  }
  & ::v-deep .vs-input--placeholder {
    padding: 0 4px;
  }
  .phone-auth-container ::v-deep .vs-row {
    margin: 4px 0;
  }
}
</style>
